export default "__VITE_ASSET__CaWsyWUt__"